/* eslint-disable no-console */
export const generateLogMessagePrefix = (mfeName, logLevel) => {
    return `[${mfeName}] ${logLevel}:`;
};
